.ADGWrapper
    padding: 0 20px
    position: relative
    width: 100%
    height: 345px
    min-height: 0
    .ADGShowMore
        position: absolute
        right: 10px
        bottom: 10px
        padding: 5px 10px
        border-radius: $globalSettingsRoundingSmall
        background: rgb($globalSettingsBackgroundPrimary)
        display: flex
        justify-content: center
        align-items: center
        cursor: pointer
        box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)

    .ADGImage
        cursor: pointer

    .AGDField
        flex-basis: calc(50% - 5px)
        flex-shrink: 0
        border-radius: $globalSettingsRounding
        min-width: 0
        min-height: 0

    .ADGFirstContainer
        position: relative
        width: 100%
        height: 100%
        display: flex
        flex-direction: row
        justify-content: space-between
        gap: 10px
        img
            object-fit: cover
            max-width: 100%
            min-height: 100%
        .ADGFirstImage
            height: 100%
            flex-grow: 1
            overflow: hidden
        .ADGSecondContainer
            height: 100%
            flex-grow: 1
            display: flex
            flex-direction: column
            justify-content: space-between
            gap: 10px
            @media not all and #{$tablet}
                display: none
            .ADGSecondImage
                width: 100%
                flex-grow: 1
                overflow: hidden
            .ADGThirdContainer
                width: 100%
                flex-grow: 1
                display: flex
                flex-direction: row
                justify-content: space-between
                gap: 10px
                .ADGThirdImage
                    width: 100%
                    flex-grow: 1
                    overflow: hidden
                .ADGFourthImage
                    width: 100%
                    height: 100%
                    overflow: hidden
                    flex-grow: 1

.ADGFWrapper
    position: relative
    width: 100%
    min-height: 0
    padding: 0 20px
    display: flex
    flex-direction: column
    gap: 20px
    img
        object-fit: cover
        max-width: 100%
        border-radius: $globalSettingsRounding
    \rentware-image
        min-height: 300px
        & *
            min-height: 300px
            border-radius: $globalSettingsRounding
